import { useState } from "react";

const KEY = "nordiguard_vehicle";
const EMPTY = { marque: "", modele: "", annee: "" };

// Véhicule choisi une fois, mémorisé partout (accueil, produits, fiche, checkout)
export const useVehicleState = () => {
  const [vehicle, setVehicle] = useState(() => {
    try {
      return { ...EMPTY, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
    } catch {
      return EMPTY;
    }
  });

  const update = (v) => {
    setVehicle(v);
    try {
      localStorage.setItem(KEY, JSON.stringify(v));
    } catch {}
  };

  return [vehicle, update];
};
